export default function(a, b) {
  return a - b;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-contour/src/ascending.js
// module id = 1426
// module chunks = 0